import { render } from "./print-feedback.vue?vue&type=template&id=375b39b9&scoped=true&ts=true"
import script from "./print-feedback.vue?vue&type=script&lang=ts"
export * from "./print-feedback.vue?vue&type=script&lang=ts"

import "./print-feedback.vue?vue&type=style&index=0&id=375b39b9&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375b39b9"]])

export default __exports__